import { createAction } from '@reduxjs/toolkit';
import { User } from '../../types/user';

import {SET_USER} from './types';

export const setUser = createAction<User>(SET_USER);

